import * as React from 'react';
import Box from '@mui/material/Box';

import axios from 'axios';
import { genpostURL } from '../../../../_getjson';
import Listpermision from './compronent/listpermision/listpermision';

export default function Reportpremissionnanage() {
    const [value, setValue] = React.useState('1');
    const [mainData, setmainData] = React.useState([]);
    const [reportData, setreportData] = React.useState([]);
    const [permisionData, setpermisionData] = React.useState([]);
    const [disabledb_save, setdisabledb_save] = React.useState(true);


    //----------------------------alert ----------------------------
    const [color, setColor] = React.useState("")
    const [opensnackbar, setOpensnackbar] = React.useState(false)
    const [autoClose, setAutoClose] = React.useState(3600)
    const [messagealert, setMessagealert] = React.useState("")
    const [icon, setIcon] = React.useState("")


    const [openbackdrop, setopenbackdrop] = React.useState(false)
    React.useEffect(() => {
        checkData()
        return () => {
        }
    }, [permisionData])

    React.useEffect(() => {
        listData()
        return () => {
        }
    }, [reportData])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const resmainData = (e) => {
        console.log("resuserData", e);
        setmainData(e)

    };
    const resreportData = (e) => {
        console.log("resreportData", e);
        setreportData(e)
    };
    const checkData = (e) => {
        console.log("checkData", permisionData.length);
        if (permisionData.length > 0 && permisionData[0].code !== "") {
            setdisabledb_save(false)
        } else {
            setdisabledb_save(true)
        }
    };

    const listData = async (e) => {
        setopenbackdrop(true)
        let element = []

        mainData.forEach(melement => {
            reportData.forEach(selement => {
                if (selement.code !== "") {
                    element.push({ gcode: melement.code, rcode: selement.code })
                }
            });

        });

        await setpermisionData(element)

        await setopenbackdrop(false)
    };
    const SaveData = async (e) => {
        console.log("saveonClick", permisionData);

        const parameter = new URLSearchParams();

        parameter.append("permisionData", JSON.stringify(permisionData));

        let url = "reportmanage/permision?"
        // let url = "/permision?"
        // await axios.post(genpostURL(url), parameter).then(res => {
        await axios.post(genpostURL(url), parameter).then(res => {
            console.log("resdata", res.data);
            if (res.data.status === "success") {

                setMessagealert("บันทึกสำเร็จ")
                setColor("success")
                setOpensnackbar(true)
                setIcon(< CheckCircleOutlineRoundedIcon />)
                setTimeout(() => {
                    setmainData([])
                    setreportData([])
                }, 30);
            }
        })
    }
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <Listpermision />
        </Box>
    );
}
